import { useQuery } from '@tanstack/react-query';
import { BaseResponse, IEventHome, IListEvent, IEventDetail, IMastEnvs } from "interfaces"
import { axiosInstanceAuth } from "./client"
import React from 'react';

export const useGetEvents = (userId?: number, intervalSec?: number, status?: "error" | "success" | "pending") => {
    let intervalMs = 0
    if (intervalSec) {
        intervalMs = intervalSec * 1000
    }
    return useQuery({
        queryKey: ['GET EVENTS', userId || ''],
        queryFn: async () => {
            const res = await axiosInstanceAuth.get(`/events`) as BaseResponse<IEventHome[]>
            return res
        },
        refetchInterval: intervalMs,
        staleTime: 2 * 6 * 1000,
        enabled: !!userId && status !== "pending", 
    })
}

export const useGetListEvent = (params: { page: number; per: number }) => {
	return useQuery({
		queryKey: ["GET_LIST_EVENTS", params.page, params.per],
		queryFn: async () => {
			const res = await axiosInstanceAuth.get(
				`/events/filtering?page=${params.page}&per=${params.per}`
			);
			return res as BaseResponse<IListEvent>;
		},
		enabled: !!params.page && !!params.per,
	});
};

export const useGetDetailEvent = (id: number) => {
	return useQuery({
		queryKey: ["GET DETAIL EVENTS", id],
		queryFn: async () => {
			const res = await axiosInstanceAuth.get(`/events/${id}`);
			return res as BaseResponse<IEventDetail>;
		},
		enabled: !!id,
	});
};

export const useGetEventDisplaySec = () => {
  const query = useQuery<BaseResponse<IMastEnvs>, Error>({
    queryKey: ["GET_EVENT_DISPLAY_SEC"],
    queryFn: async () => {
      const res = await axiosInstanceAuth.get(
        "/mast_envs/show_by_key?key=EVENT_DISPLAY_RELOAD_SEC"
      );
      return res as BaseResponse<IMastEnvs>;
    },
    staleTime: Infinity,
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 3000),
    refetchInterval: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
  });

  const sec = React.useMemo<number>(() => {
    const raw = query.data?.data?.value;
    const parsed = raw != null ? Number(raw) : NaN;

    if (!isNaN(parsed)) return parsed;

    if (query.isError) return 10;

    return 10;
  }, [query.data, query.isError]);

  return { ...query, sec };
};
